import React from 'react';


const FormRadioGroup = function (props) {
  const {
    selectedValue, text, children, name
  } = props;
  const type = 'radio';
  const headName = `head_${name}`;

  return (
    <div role="group" aria-labelledby={headName} className={`formElement type-${type}`}>
      <span id={headName}>{text}</span>
      <div>
        {
          React.Children.map(children, child => React.cloneElement(child, { name, type, selectedValue }))
        }
      </div>
    </div>
  );
};

export default FormRadioGroup;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormRadioGroup.js